import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getDdrmsRepositoryDocuments, loadDdrmsRepositoryDocs } from "../../store/ddrmsDocument";
import DataMapping from "./DataMapping";
import AddDataTypeMapping from "./AddDataTypeMapping";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../store/candidate";
import useDocDownload from "../../hooks/useDocDownload";
import { getDataTypeMappings, loadAllDataTypeMappings, deleteDataTypeMapping, getMappingAddedStatus } from "../../store/dataTypes";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";

const GenerateContract = (props) => {
    const { showHide, uploadType, handleModalShowHide, workflowTask, app, applicantObj, viewType, prevItem, ddrmsDocId, defaultMappingId, embedded = false, bodyOnly = false, autoSave = false, deferSave = false, initialGeneratedData = null, onStageGenerated = null } = props;

    const [repositoryDocs, setRepositoryDocs] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedKey, setSelectedKey] = useState("selectDocument");
    const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
    const [repositoryLoading, setRepositoryLoading] = useState(false);
    const [wfTask, setWfTask] = useState(null);
    const [editingProfile, setEditingProfile] = useState(null);
    const [dataTypeMappings, setDataTypeMappings] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);

    const [handleDownloadFile] = useDocDownload();

    const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);

    const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
    const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
    const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);
    const dataTypeMappingsSelector = useSelector(getDataTypeMappings);
    const mappingAddedStatusSelector = useSelector(getMappingAddedStatus);

    const dispatch = useDispatch();
    const repositoryLoadStartedRef = useRef(false);

    useEffect(() => {
        setSelectedKey("selectDocument");
    }, [viewType]);

    useEffect(() => {
        dispatch(loadAllDataTypeMappings());
    }, []);

    useEffect(() => {
        let perfType = "";
        if (uploadType === "Subcontractor") {
            perfType = "Sub-Contractors";
        } else if (uploadType === "Candidate") {
            perfType = "candidate";
        } else if (uploadType === "Recruiter") {
            perfType = "Recruiter";
        }
        if (dataTypeMappingsSelector) {
            setDataTypeMappings(dataTypeMappingsSelector.filter(x => x.type === perfType));
        }
    }, [dataTypeMappingsSelector, uploadType]);

    useEffect(() => {
        if (mappingAddedStatusSelector) {
            if (isDeleting) {
                getAlert("", "Deleted Successfully", "success");
                setIsDeleting(false);
                dispatch(loadAllDataTypeMappings());
            }
        }
    }, [mappingAddedStatusSelector, isDeleting]);

    const handleDeleteProfile = async (item) => {
        const result = await getConfirmAlert("Warning", `Are you sure you want to delete the mapping profile "${item.name}"?`, "warning");
        if (result.isConfirmed) {
            setIsDeleting(true);
            dispatch(deleteDataTypeMapping(item.id));
        }
    };

    useEffect(() => {
        console.log(workflowTask);
        if (workflowTask?.ciid > 0) {
            handleDocRefresh(workflowTask)
            setWfTask(workflowTask);
        } else if (applicantObj?.id) {

            if (prevItem?.applications?.length > 0)
                handleDocRefresh({ ciid: prevItem.applications[0].ciid })

            if (uploadType === "Subcontractor") {
                let partnerUsrId = applicantObj?.id;
                if (viewType === "candidateList")
                    partnerUsrId = applicantObj?.subcontractor?.parentid;
                if (partnerUsrId > 0) {
                    dispatch(loadSubcontractorWfTask(partnerUsrId));
                    setWfTaskReqCount(wfTaskReqCount + 1)
                }
            }

            if (uploadType === "Recruiter") {
                let partnerUsrId = applicantObj?.id;
                if (viewType === "candidateList")
                    partnerUsrId = applicantObj?.recruiter?.parentid;
                if (partnerUsrId > 0) {
                    dispatch(loadRecruiterWfTask(partnerUsrId));
                    setWfTaskReqCount(wfTaskReqCount + 1)
                }
            }

            if (uploadType === "Candidate") {
                dispatch(loadCandidateWfTask(applicantObj?.id));
                setWfTaskReqCount(wfTaskReqCount + 1);
            }
        }
    }, []);

    useEffect(() => {
        console.log(subsCurrentWfTaskSelector)
        if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
            setWfTask(subsCurrentWfTaskSelector)
            setWfTaskReqCount(0);
        }
        else if (subsCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            let partnerUsrId = applicantObj?.id;
            if (viewType === "candidateList")
                partnerUsrId = applicantObj?.subcontractor?.parentid;
            if (partnerUsrId > 0) {
                setWfTaskReqCount(wfTaskReqCount + 1)
                dispatch(subsCurrentWfTaskReceived(null));
                setTimeout(() => {
                    dispatch(loadSubcontractorWfTask(partnerUsrId));
                }, 1000);
            }
        }
    }, [subsCurrentWfTaskSelector]);

    useEffect(() => {
        console.log(recCurrentWfTaskSelector)
        if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
            setWfTask(recCurrentWfTaskSelector)
            setWfTaskReqCount(0);
        } else if (recCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            let partnerUsrId = applicantObj?.id;
            if (viewType === "candidateList")
                partnerUsrId = applicantObj?.recruiter?.parentid;
            if (partnerUsrId > 0) {
                setWfTaskReqCount(wfTaskReqCount + 1)
                dispatch(recCurrentWfTaskReceived(null));
                setTimeout(() => {
                    dispatch(loadRecruiterWfTask(partnerUsrId));
                }, 1000);
            }
        }
    }, [recCurrentWfTaskSelector]);

    useEffect(() => {
        console.log(candidateCurrentWfTaskSelector)
        if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
            setWfTask(candidateCurrentWfTaskSelector)
            setWfTaskReqCount(0)
        } else if (candidateCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
            setWfTaskReqCount(wfTaskReqCount + 1)
            dispatch(candidateCurrentWfTaskReceived(null));
            dispatch(loadCandidateWfTask(applicantObj?.id));
        }
    }, [candidateCurrentWfTaskSelector]);

    useEffect(() => {
        if (wfTask?.ciid > 0) {
            handleDocRefresh(wfTask);
        }
    }, [wfTask]);

    useEffect(() => {
        if (ddrmsRepositoryDocumentsSelector.length > 0) {
            const filterDocx = ddrmsRepositoryDocumentsSelector.filter(x => x.fileExtension === "docx");
            setRepositoryDocs(filterDocx);
        }
        else {
            setRepositoryDocs([]);
        }
        if (repositoryLoadStartedRef.current) {
            setRepositoryLoading(false);
            repositoryLoadStartedRef.current = false;
        }
    }, [ddrmsRepositoryDocumentsSelector]);

    useEffect(() => {
        if (ddrmsDocId && repositoryDocs.length > 0) {
            const found = repositoryDocs.find(doc => doc.id === parseInt(ddrmsDocId));
            if (found) {
                setSelectedDoc(found);
                setSelectedDocId(found.id);
                setSelectedKey("generateDocument");
            }
        }
    }, [ddrmsDocId, repositoryDocs]);

    const handleDocRefresh = (task = wfTask) => {
        if (task?.ciid > 0) {
            repositoryLoadStartedRef.current = true;
            setRepositoryLoading(true);
            dispatch(loadDdrmsRepositoryDocs(task.ciid));
        }
    }


    const handleResetSelection = () => {
        setSelectedDocId(0);
        setSelectedDoc(null);
    }

    const handleSelection = (item) => {
        setSelectedDoc(item);
        setSelectedDocId(item.id);
    };

    const handleGenerateFromSelection = (item) => {
        setSelectedDoc(item);
        setSelectedDocId(item.id);
        setSelectedKey("generateDocument");
    };

    const handleCloseMapping = (type) => {
        setSelectedDocId(0);
        setSelectedDoc(null);
        if (type === "stage") {
            handleModalShowHide(type);
            return;
        }
        setTimeout(() => {
            handleModalShowHide(type)
        }, 3000);
    }

    const handleSelectedKey = (key) => {
        setSelectedKey(key);
    }

    const personName = [
        applicantObj?.performername,
        applicantObj?.firstName,
        applicantObj?.name,
        applicantObj?.lastName
    ].filter(Boolean).join(" ");
    const displayName = personName || applicantObj?.email || applicantObj?.performeremail || "Selected profile";
    const canGenerateDocuments = true;
    const selectedDocReady = selectedDocId > 0;
    const showRepositoryLoading = repositoryLoading;
    const showRepositoryEmpty = !repositoryLoading && repositoryDocs.length === 0;
    const Container = embedded ? "div" : Modal;

    return <>
        <style>{`
            .gc-shell,
            .gc-shell button,
            .gc-shell input,
            .gc-shell select,
            .gc-shell textarea {
                font-family: "Open Sans", "Segoe UI", Roboto, sans-serif !important;
            }
            @keyframes gcFadeIn {
                from { opacity: 0; transform: translateY(6px); }
                to { opacity: 1; transform: translateY(0); }
            }
            .modal-backdrop {
                z-index: 1080 !important;
            }
            .modal {
                z-index: 1090 !important;
            }
            .modal-backdrop.show {
                backdrop-filter: blur(8px) !important;
                -webkit-backdrop-filter: blur(8px) !important;
                background-color: rgba(15, 23, 42, 0.45) !important;
                opacity: 1 !important;
            }
            .modal.fade .gc-modal.modal-dialog {
                transform: scale(0.95) !important;
                transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
            }
            .modal.show .gc-modal.modal-dialog {
                transform: scale(1) !important;
            }
            .gc-modal {
                max-width: 90% !important;
                width: 1200px !important;
            }
            .gc-modal .modal-content {
                border: 0;
                border-radius: 16px;
                overflow: hidden;
                background: #ffffff;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
                max-height: calc(100vh - 60px);
                display: flex;
                flex-direction: column;
            }
            .gc-shell {
                animation: gcFadeIn 0.25s ease both;
                background: #ffffff;
                max-height: calc(100vh - 60px);
                display: flex;
                flex-direction: column;
                min-height: 0;
            }
            .gc-header {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 18px;
                padding: 22px 24px 18px;
                background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
                border-bottom: 1px solid #f1f5f9;
            }
            .gc-header-left {
                display: flex;
                align-items: flex-start;
                gap: 14px;
                min-width: 0;
                flex: 1;
            }
            .gc-icon-box {
                width: 44px;
                height: 44px;
                border-radius: 12px;
                background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-size: 18px;
                flex-shrink: 0;
                box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
            }
            .gc-title { font-size: 18px; font-weight: 800; color: #0f172a; line-height: 1.2; margin: 0; }
            .gc-subtitle { font-size: 13px; color: #64748b; margin: 6px 0 0; }
            .gc-meta-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
            .gc-meta-pill {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                padding: 4px 10px;
                border-radius: 99px;
                background: #ffffff;
                border: 1px solid #e2e8f0;
                color: #475569;
                font-size: 12px;
                font-weight: 700;
                max-width: 320px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .gc-meta-pill i { font-size: 11px; color: #2563eb; flex-shrink: 0; }
            .gc-close-btn {
                width: 38px;
                height: 38px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-radius: 8px;
                border: 1px solid #cbd5e1;
                background: #ffffff;
                color: #475569;
                cursor: pointer;
                transition: all 0.15s ease;
                flex-shrink: 0;
            }
            .gc-close-btn:hover { background: #f8fafc; border-color: #94a3b8; color: #0f172a; transform: translateY(-1px); }
            .gc-body {
                padding: 0 24px 24px;
                background: #ffffff;
                overflow: hidden;
                min-height: 0;
                display: flex;
                flex-direction: column;
            }
            .gc-tab-bar {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 2px;
                padding-top: 14px;
                margin-bottom: 16px;
                border-bottom: 1px solid #e2e8f0;
                overflow: visible;
                scrollbar-width: none;
                flex: 0 0 auto;
            }
            .gc-tab-bar::-webkit-scrollbar {
                display: none;
            }
            .gc-tab-btn {
                min-height: 44px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                padding: 10px 14px;
                border: 0;
                border-radius: 8px 8px 0 0;
                background: transparent;
                color: #64748b;
                font-size: 13px;
                font-weight: 600;
                cursor: pointer;
                transition: color 0.2s ease, background 0.2s ease;
                position: relative;
                white-space: nowrap;
                outline: none;
            }
            .gc-tab-btn:hover {
                color: #1e293b;
                background: rgba(37, 99, 235, 0.04);
            }
            .gc-tab-btn:focus,
            .gc-tab-btn:focus-visible,
            .gc-tab-btn:active {
                outline: none !important;
                box-shadow: none !important;
                border-color: transparent !important;
            }
            .gc-tab-btn.active {
                color: #2563eb;
                font-weight: 700;
                background: rgba(37, 99, 235, 0.06);
            }
            .gc-tab-btn::after {
                content: "";
                position: absolute;
                bottom: -2px;
                left: 0;
                right: 0;
                height: 2px;
                background: #2563eb;
                border-radius: 2px 2px 0 0;
                transform: scaleX(0);
                transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
            }
            .gc-tab-btn.active::after {
                transform: scaleX(1);
            }
            .gc-tab-btn.tab-locked .gc-tab-badge {
                background: rgba(245, 158, 11, 0.1);
                color: #b45309;
                border-color: rgba(245, 158, 11, 0.2);
            }
            .gc-tab-index {
                width: 20px;
                height: 20px;
                border-radius: 999px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: #f1f5f9;
                color: #64748b;
                border: 1px solid #e2e8f0;
                font-size: 11px;
                font-weight: 700;
                line-height: 1;
                flex-shrink: 0;
            }
            .gc-tab-btn.active .gc-tab-index {
                background: rgba(37, 99, 235, 0.1);
                color: #1d4ed8;
                border-color: rgba(37, 99, 235, 0.2);
            }
            .gc-tab-text {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                min-width: 0;
            }
            .gc-tab-text span {
                display: inline-block;
                max-width: 180px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .gc-tab-text small {
                display: none;
            }
            .gc-tab-badge {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                min-width: 20px;
                height: 20px;
                padding: 0 6px;
                border-radius: 999px;
                font-size: 11px;
                font-weight: 700;
                background: #f1f5f9;
                color: #64748b;
                border: 1px solid #e2e8f0;
                line-height: 1;
                transition: all 0.2s ease;
            }
            .gc-tab-badge.done,
            .gc-tab-btn.active .gc-tab-badge {
                background: rgba(37, 99, 235, 0.1);
                color: #1d4ed8;
                border-color: rgba(37, 99, 235, 0.2);
            }
            .gc-panel {
                border: 1px solid rgba(226, 232, 240, 0.95);
                border-radius: 14px;
                overflow: hidden;
                background: #ffffff;
                box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
                min-height: 0;
                display: flex;
                flex-direction: column;
            }
            .gc-toolbar {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 16px;
                padding: 16px;
                background: #f8fafc;
                border-bottom: 1px solid #e2e8f0;
            }
            .gc-section-label {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                margin: 0;
                color: #334155;
                font-size: 12px;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.06em;
            }
            .gc-section-label i { color: #2563eb; }
            .gc-note { margin: 6px 0 0; color: #64748b; font-size: 12.5px; font-weight: 600; }
            .gc-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }
            .gc-action-btn {
                min-height: 38px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                font-size: 12px;
                font-weight: 700;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.15s ease;
                padding: 8px 13px;
                border: 1px solid #dbe3ef;
                background: #ffffff;
                color: #334155;
                white-space: nowrap;
            }
            .gc-action-btn:hover { background: #f8fafc; border-color: #bfdbfe; color: #1d4ed8; transform: translateY(-1px); }
            .gc-action-btn.primary { background: #2563eb; border-color: #2563eb; color: #ffffff; }
            .gc-action-btn.primary:hover { background: #1d4ed8; border-color: #1d4ed8; color: #ffffff; }
            .gc-doc-list {
                display: flex;
                flex-direction: column;
                gap: 8px;
                max-height: calc(100vh - 385px);
                min-height: 180px;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 16px;
                background: #ffffff;
                scrollbar-width: thin;
                scrollbar-color: #94a3b8 #f1f5f9;
            }
            .gc-doc-list::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .gc-doc-list::-webkit-scrollbar-track {
                background: transparent;
            }
            .gc-doc-list::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
            }
            .gc-doc-list::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
            }
              .gc-doc-row {
                  display: grid;
                  grid-template-columns: auto 34px minmax(0, 1fr) auto auto;
                  align-items: center;
                  gap: 12px;
                  width: 100%;
                  padding: 16px 16px 16px 18px;
                  background: #ffffff;
                  border: 1px solid #dbe3ef;
                  border-radius: 10px;
                  color: inherit;
                  text-align: left;
                  cursor: pointer;
                  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
                  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease, border-left 0.15s ease, padding-left 0.15s ease;
                  position: relative;
              }
             .gc-doc-row:hover, .gc-doc-row:focus { border-color: #bfdbfe; box-shadow: 0 8px 20px rgba(37, 99, 235, 0.08); transform: translateY(-1px); outline: none; }
             .gc-doc-row.selected {
                 background: #f8fbff;
                 border-color: #93c5fd;
                 border-left: 4px solid #2563eb;
                 padding-left: 15px;
             }
            .gc-doc-icon {
                width: 34px;
                height: 34px;
                border-radius: 8px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: #eff6ff;
                color: #2563eb;
                border: 1px solid #dbeafe;
                font-size: 15px;
            }
            .gc-doc-main { min-width: 0; }
            .gc-doc-title { display: block; color: #0f172a; font-weight: 800; font-size: 14px; line-height: 1.25; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
            .gc-doc-meta { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-top: 5px; color: #64748b; font-size: 12px; font-weight: 600; }
            .gc-status {
                display: inline-flex;
                align-items: center;
                gap: 5px;
                padding: 4px 10px;
                border-radius: 99px;
                font-size: 11px;
                font-weight: 700;
                background: #eff6ff;
                color: #1d4ed8;
                border: 1px solid #bfdbfe;
                white-space: nowrap;
            }
            .gc-status.done {
                background: #f0fdf4;
                color: #16a34a;
                border-color: #dcfce7;
            }
            .gc-doc-checkbox {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                position: relative;
                width: 18px;
                height: 18px;
                cursor: pointer;
            }
            .gc-doc-checkbox input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
            }
            .gc-checkbox-custom {
                position: absolute;
                top: 0;
                left: 0;
                height: 18px;
                width: 18px;
                background-color: #ffffff;
                border: 2px solid #cbd5e1;
                border-radius: 4px;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .gc-checkbox-custom::after {
                content: "";
                display: none;
                width: 5px;
                height: 9px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
                margin-bottom: 2px;
            }
            .gc-doc-row.selected .gc-checkbox-custom {
                background-color: #2563eb;
                border-color: #2563eb;
            }
            .gc-doc-row.selected .gc-checkbox-custom::after {
                display: block;
            }
            .gc-doc-row:hover .gc-checkbox-custom {
                border-color: #94a3b8;
            }
            .gc-doc-row.selected:hover .gc-checkbox-custom {
                border-color: #1d4ed8;
                background-color: #1d4ed8;
            }
             .gc-row-download,
             .gc-row-generate {
                 min-height: 34px;
                 display: inline-flex;
                 align-items: center;
                 justify-content: center;
                 gap: 6px;
                 padding: 7px 12px;
                 border-radius: 8px;
                 border: 1px solid #dbe3ef;
                 background: #ffffff;
                 color: #475569;
                 font-size: 12px;
                 font-weight: 800;
                 cursor: pointer;
                 white-space: nowrap;
                 transition: all 0.15s ease;
             }
             .gc-row-download:hover,
             .gc-row-generate:hover {
                 background: #f8fafc;
                 border-color: #bfdbfe;
                 color: #1d4ed8;
                 transform: translateY(-1px);
             }
            .gc-action-btn:disabled {
                opacity: 0.6;
                cursor: not-allowed;
                transform: none;
            }
            .gc-state,
            .gc-empty {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 180px;
                border: 1px dashed #cbd5e1;
                border-radius: 12px;
                background: #f8fafc;
                color: #64748b;
                text-align: center;
                padding: 28px;
            }
            .gc-empty-icon {
                width: 42px;
                height: 42px;
                border-radius: 12px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: #eff6ff;
                color: #2563eb;
                margin-bottom: 10px;
                font-size: 18px;
            }
            .gc-empty h5,
            .gc-state h5,
            .gc-no-selection h5 { margin: 0 0 4px; color: #0f172a; font-weight: 800; }
            .gc-empty p,
            .gc-state p,
            .gc-no-selection p { margin: 0; font-size: 13px; }
            .gc-no-selection {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 260px;
                text-align: center;
                padding: 34px;
                color: #64748b;
                background: #f8fafc;
            }
            .gc-no-selection-icon {
                width: 48px;
                height: 48px;
                border-radius: 14px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: #fff7ed;
                color: #b45309;
                border: 1px solid #ffedd5;
                margin-bottom: 12px;
                font-size: 18px;
            }
            .gc-no-selection .gc-action-btn { margin-top: 16px; }
            .gc-selected-summary {
                display: grid;
                grid-template-columns: 34px minmax(0, 1fr) auto;
                align-items: center;
                gap: 12px;
                padding: 16px;
                background: #f8fafc;
                border-bottom: 1px solid #e2e8f0;
            }
            .gc-mapping-wrap {
                padding: 16px;
                flex: 1;
                overflow-y: auto;
                min-height: 0;
                scrollbar-width: thin;
                scrollbar-color: #94a3b8 #f1f5f9;
            }
            .gc-mapping-wrap::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .gc-mapping-wrap::-webkit-scrollbar-track {
                background: transparent;
            }
            .gc-mapping-wrap::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
            }
            .gc-mapping-wrap::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
            }
            .gc-footer {
                padding: 16px 24px;
                background: #f8fafc;
                border-top: 1px solid #e2e8f0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
            .gc-footer-close-btn {
                min-height: 38px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                font-size: 13px;
                font-weight: 700;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.15s ease;
                padding: 8px 16px;
                border: 1px solid #cbd5e1;
                background: #ffffff;
                color: #334155;
                white-space: nowrap;
            }
            .gc-footer-close-btn:hover {
                background: #f8fafc;
                border-color: #94a3b8;
                transform: translateY(-1px);
            }
            .gc-profile-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
                gap: 16px;
                padding: 20px;
                max-height: calc(100vh - 385px);
                min-height: 220px;
                overflow-y: auto;
                background: #ffffff;
                scrollbar-width: thin;
                scrollbar-color: #94a3b8 #f1f5f9;
            }
            .gc-profile-grid::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .gc-profile-grid::-webkit-scrollbar-track {
                background: transparent;
            }
            .gc-profile-grid::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
            }
            .gc-profile-grid::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
            }
            .gc-profile-card {
                border: 1px solid #cbd5e1;
                border-left: 4px solid #0f766e;
                border-radius: 12px;
                background: #ffffff;
                padding: 18px;
                display: flex;
                flex-direction: column;
                gap: 12px;
                transition: all 0.2s ease;
                box-shadow: 0 4px 12px rgba(15, 23, 42, 0.01);
                min-height: 160px;
            }
            .gc-profile-card:hover {
                border-color: #94a3b8;
                box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
                transform: translateY(-1px);
            }
            .gc-profile-header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                gap: 12px;
            }
            .gc-profile-title {
                font-size: 15px;
                font-weight: 800;
                color: #0f172a;
                margin: 0;
                text-align: left;
            }
            .gc-profile-notes {
                font-size: 13px;
                color: #64748b;
                margin: 0;
                line-height: 1.4;
                text-align: left;
            }
            .gc-profile-meta {
                display: flex;
                align-items: center;
                gap: 12px;
                margin-top: 4px;
                font-size: 12px;
                color: #475569;
                font-weight: 700;
                text-align: left;
            }
            .gc-profile-meta i {
                color: #2563eb;
            }
            .gc-profile-actions {
                display: flex;
                align-items: center;
                gap: 8px;
                justify-content: flex-end;
                margin-top: auto;
                border-top: 1px solid #f1f5f9;
                padding-top: 12px;
            }
            .gc-action-btn.danger:hover {
                background: #fef2f2 !important;
                border-color: #ef4444 !important;
                color: #dc2626 !important;
                transform: translateY(-1px);
            }
            @media (max-width: 768px) {
                .gc-header, .gc-toolbar { flex-direction: column; align-items: stretch; }
                .gc-tab-bar { align-items: stretch; border-bottom: 0; }
                .gc-tab-btn { flex: 1 1 100%; border-radius: 8px; }
                .gc-tab-btn::after { bottom: 0; }
                .gc-doc-row { grid-template-columns: auto 34px minmax(0, 1fr); }
                .gc-selected-summary { grid-template-columns: 34px minmax(0, 1fr); }
                .gc-status, .gc-row-download, .gc-row-generate { grid-column: 1 / -1; justify-self: flex-start; }
            }
        `}</style>
        <Container
            {...(embedded ? { className: `gc-embedded${bodyOnly ? " gc-body-only" : ""}` } : {
                show: showHide,
                size: "xl",
                centered: true,
                onHide: () => handleModalShowHide(""),
                dialogClassName: "gc-modal",
                backdrop: "static",
                keyboard: false
            })}
        >
            <Modal.Body className="p-0">
                <div className="gc-shell">
                    {!bodyOnly && <div className="gc-header">
                        <div className="gc-header-left">
                            <div className="gc-icon-box">
                                <i className="fa fa-file-text-o" />
                            </div>
                            <div className="gc-title-block">
                                <h2 className="gc-title">Generate Documents</h2>
                                <p className="gc-subtitle">
                                    Generate contracts for {displayName}.
                                </p>
                                <div className="gc-meta-row">
                                    <span className="gc-meta-pill">
                                        <i className="fa fa-briefcase" /> {uploadType || "Document"}
                                    </span>
                                    {wfTask?.ciid > 0 && (
                                        <span className="gc-meta-pill">
                                            <i className="fa fa-hashtag" /> CIID: {wfTask.ciid}
                                        </span>
                                    )}
                                    {canGenerateDocuments && (
                                        <span className="gc-meta-pill">
                                            <i className="fa fa-files-o" /> {repositoryDocs.length} DOCX templates
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="gc-close-btn"
                            onClick={() => handleModalShowHide("")}
                            title="Close"
                        >
                            <i className="fa fa-times" />
                        </button>
                    </div>}

                    <div className="gc-body">
                        {!bodyOnly && <div className="gc-tab-bar" role="tablist" aria-label="Generate contract actions">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "selectDocument"}
                                className={`gc-tab-btn ${selectedKey === "selectDocument" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("selectDocument")}
                            >
                                <span className="gc-tab-text">
                                    <span>Select Document</span>
                                    <small>{selectedDocReady ? `${selectedDoc?.name} (ID: ${selectedDoc?.id})` : "Choose a DOCX template"}</small>
                                </span>
                                <span className={`gc-tab-badge ${selectedDocReady ? "done" : "pending"}`}>
                                    <i className={`fa ${selectedDocReady ? "fa-check" : "fa-clock-o"}`} />
                                </span>
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "generateDocument"}
                                className={`gc-tab-btn ${selectedKey === "generateDocument" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("generateDocument")}
                            >
                                <span className="gc-tab-text">
                                    <span>Generate Document</span>
                                    <small>{selectedDocReady ? `Ready to generate (ID: ${selectedDoc?.id})` : "No document selected"}</small>
                                </span>
                                <span className={`gc-tab-badge ${selectedDocReady ? "done" : "pending"}`}>
                                    <i className="fa fa-magic" />
                                </span>
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "manageMappings"}
                                className={`gc-tab-btn ${selectedKey === "manageMappings" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("manageMappings")}
                            >
                                <span className="gc-tab-text">
                                    <span>Manage Mappings</span>
                                    <small>View/edit/delete profiles</small>
                                </span>
                                <span className="gc-tab-badge">
                                    <i className="fa fa-list" />
                                </span>
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={selectedKey === "addMapping"}
                                className={`gc-tab-btn ${selectedKey === "addMapping" ? "active" : ""}`}
                                onClick={() => handleSelectedKey("addMapping")}
                            >
                                <span className="gc-tab-text">
                                    <span>{editingProfile ? "Edit Mapping" : "New Mapping"}</span>
                                    <small>Mapping setup</small>
                                </span>
                                <span className={`gc-tab-badge ${selectedDocReady ? "done" : "pending"}`}>
                                    <i className="fa fa-pencil-square-o" />
                                </span>
                            </button>
                        </div>}

                        {!bodyOnly && canGenerateDocuments && selectedKey === "selectDocument" && (
                            <div className="gc-panel" role="tabpanel">
                                <div className="gc-toolbar">
                                    <div>
                                        <div className="gc-section-label">
                                            <i className="fa fa-folder-open-o" /> Select Document
                                        </div>
                                        <p className="gc-note">Select one DOCX template before generating the document.</p>
                                    </div>
                                    <div className="gc-actions">
                                        <button className="gc-action-btn" onClick={handleResetSelection} disabled={!selectedDocReady}>
                                            <i className="fa fa-refresh" /> Reset
                                        </button>
                                        <button className="gc-action-btn primary" onClick={() => handleDocRefresh(wfTask)} disabled={repositoryLoading}>
                                            <i className={`fa ${repositoryLoading ? "fa-spinner fa-spin" : "fa-repeat"}`} /> {repositoryLoading ? "Loading" : "Refresh"}
                                        </button>
                                    </div>
                                </div>
                                <div className="gc-doc-list">
                                    {showRepositoryLoading && (
                                        <div className="gc-state gc-state-loading">
                                            <div className="gc-empty-icon"><i className="fa fa-spinner fa-spin" /></div>
                                            <h5>Loading DDRMS documents</h5>
                                            <p>Fetching available DOCX templates for this workflow.</p>
                                        </div>
                                    )}
                                    {showRepositoryEmpty && (
                                        <div className="gc-state gc-state-empty">
                                            <div className="gc-empty-icon"><i className="fa fa-inbox" /></div>
                                            <h5>No DOCX templates found</h5>
                                            <p>Refresh the repository or upload a DOCX template before generating a document.</p>
                                        </div>
                                    )}
                                    {!showRepositoryLoading && repositoryDocs.map((item) => (
                                        <div
                                            key={`contract-template-${item.id}`}
                                            role="button"
                                            tabIndex={0}
                                            className={`gc-doc-row ${selectedDocId === item.id ? "selected" : ""}`}
                                            onClick={() => handleSelection(item)}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter" || event.key === " ") {
                                                    event.preventDefault();
                                                    handleSelection(item);
                                                }
                                            }}
                                        >
                                            <span className="gc-doc-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedDocId === item.id}
                                                    readOnly
                                                />
                                                <span className="gc-checkbox-custom" />
                                            </span>
                                            <span className="gc-doc-icon">
                                                <i className="fa fa-file-word-o" />
                                            </span>
                                            <span className="gc-doc-main">
                                                <span className="gc-doc-title">{item.name}</span>
                                                <span className="gc-doc-meta">
                                                    <span><i className="fa fa-hashtag" /> ID: {item.id}</span>
                                                    <span><i className="fa fa-file-o" /> .{item.fileExtension}</span>
                                                </span>
                                            </span>
                                            <button
                                                type="button"
                                                className="gc-row-download"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleDownloadFile(item);
                                                }}
                                            >
                                                <i className="fa fa-download" /> Download
                                            </button>
                                            <button
                                                type="button"
                                                className="gc-row-generate"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleGenerateFromSelection(item);
                                                }}
                                            >
                                                <i className="fa fa-magic" /> Generate
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {canGenerateDocuments && (bodyOnly || selectedKey === "generateDocument") && (
                            <div className="gc-panel" role="tabpanel">
                                {!selectedDocReady && (
                                    <div className="gc-no-selection">
                                        <div className="gc-no-selection-icon"><i className="fa fa-lock" /></div>
                                        <h5>No document selected</h5>
                                        <p>Select a DOCX template in the first tab before generating the document.</p>
                                        <button className="gc-action-btn primary" onClick={() => handleSelectedKey("selectDocument")}>
                                            <i className="fa fa-arrow-left" /> Select Document
                                        </button>
                                    </div>
                                )}
                                {selectedDocReady && (
                                    <>
                                        <div className="gc-selected-summary">
                                            <div className="gc-doc-icon">
                                                <i className="fa fa-file-word-o" />
                                            </div>
                                            <div className="gc-doc-main">
                                                <span className="gc-doc-title">{selectedDoc?.name}</span>
                                                <span className="gc-doc-meta">
                                                    <span><i className="fa fa-hashtag" /> ID: {selectedDoc?.id}</span>
                                                    <span><i className="fa fa-check-circle" /> Ready to generate</span>
                                                </span>
                                            </div>
                                            {!bodyOnly && <div style={{ display: "flex", gap: "8px" }}>
                                                <button className="gc-action-btn" onClick={() => handleSelectedKey("manageMappings")}>
                                                    <i className="fa fa-list" /> Manage Mappings
                                                </button>
                                                <button className="gc-action-btn" onClick={() => handleSelectedKey("addMapping")}>
                                                    <i className="fa fa-plus" /> New Mapping
                                                </button>
                                                <button className="gc-action-btn" onClick={() => handleSelectedKey("selectDocument")}>
                                                    <i className="fa fa-exchange" /> Change
                                                </button>
                                            </div>}
                                        </div>
                                        <div className="gc-mapping-wrap">
                                            <DataMapping
                                                workflowTask={wfTask}
                                                app={app}
                                                uploadType={uploadType}
                                                selectedObj={selectedDoc}
                                                applicantObj={applicantObj}
                                                viewType={viewType}
                                                handleCloseMapping={handleCloseMapping}
                                                goBack={() => handleSelectedKey("selectDocument")}
                                                defaultMappingId={defaultMappingId}
                                                autoSave={autoSave}
                                                deferSave={deferSave}
                                                initialGeneratedData={initialGeneratedData}
                                                onStageGenerated={onStageGenerated}
                                                bodyOnly={bodyOnly} />
                                        </div>
                                    </>
                                )}
                            </div>
                        )}

                        {!bodyOnly && canGenerateDocuments && selectedKey === "manageMappings" && (
                            <div className="gc-panel" role="tabpanel">
                                <div className="gc-toolbar">
                                    <div>
                                        <div className="gc-section-label">
                                            <i className="fa fa-list" /> Manage Mappings
                                        </div>
                                        <p className="gc-note">Manage your datatype mapping profiles.</p>
                                    </div>
                                    <div className="gc-actions">
                                        <button
                                            className="gc-action-btn"
                                            onClick={() => handleSelectedKey("selectDocument")}
                                        >
                                            <i className="fa fa-arrow-left" /> Back
                                        </button>
                                        <button
                                            className="gc-action-btn primary"
                                            onClick={() => {
                                                setEditingProfile(null);
                                                handleSelectedKey("addMapping");
                                            }}
                                        >
                                            <i className="fa fa-plus" /> Add New
                                        </button>
                                    </div>
                                </div>
                                <div className="gc-profile-grid">
                                    {dataTypeMappings.length === 0 ? (
                                        <div className="gc-empty gc-empty-profile" style={{ gridColumn: "1 / -1", margin: "16px" }}>
                                            <div className="gc-empty-icon"><i className="fa fa-sliders" /></div>
                                            <h5>No mapping profiles found</h5>
                                            <p>Create a new datatype mapping profile to get started.</p>
                                        </div>
                                    ) : (
                                        dataTypeMappings.map((item) => {
                                            let fieldCount = 0;
                                            try {
                                                const parsed = JSON.parse(item.mappingJson);
                                                fieldCount = Array.isArray(parsed) ? parsed.length : 0;
                                            } catch (e) {
                                                console.error("Error parsing mappingJson", e);
                                            }
                                            return (
                                                <div key={`profile-card-${item.id}`} className="gc-profile-card">
                                                    <div className="gc-profile-header">
                                                        <div>
                                                            <h5 className="gc-profile-title">{item.name}</h5>
                                                            <div className="gc-profile-meta">
                                                                <span><i className="fa fa-hashtag" /> ID: {item.id}</span>
                                                                <span><i className="fa fa-sliders" /> {fieldCount} configured fields</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {item.notes && (
                                                        <p className="gc-profile-notes">{item.notes}</p>
                                                    )}
                                                    <div className="gc-profile-actions">
                                                        <button
                                                            type="button"
                                                            className="gc-action-btn"
                                                            onClick={() => {
                                                                setEditingProfile(item);
                                                                handleSelectedKey("addMapping");
                                                            }}
                                                        >
                                                            <i className="fa fa-pencil" /> Edit
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="gc-action-btn danger"
                                                            style={{
                                                                borderColor: "#fca5a5",
                                                                color: "#ef4444",
                                                                background: "#ffffff"
                                                            }}
                                                            onClick={() => handleDeleteProfile(item)}
                                                        >
                                                            <i className="fa fa-trash-o" /> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                        )}

                        {!bodyOnly && canGenerateDocuments && selectedKey === "addMapping" && (
                            <div className="gc-panel" role="tabpanel">
                                <div className="gc-toolbar">
                                    <div>
                                        <div className="gc-section-label">
                                            <i className="fa fa-pencil-square-o" /> {editingProfile ? "Edit Mapping" : "New Mapping"}
                                        </div>
                                        <p className="gc-note">{editingProfile ? "Modify mapping configuration" : "Configure new mapping"}</p>
                                    </div>
                                    <div className="gc-actions">
                                        <button
                                            className="gc-action-btn"
                                            onClick={() => {
                                                setEditingProfile(null);
                                                handleSelectedKey("manageMappings");
                                            }}
                                        >
                                            <i className="fa fa-arrow-left" /> Back
                                        </button>
                                    </div>
                                </div>
                                <div className="gc-mapping-wrap" style={{ padding: "20px" }}>
                                    <AddDataTypeMapping
                                        app={app}
                                        applicantObj={applicantObj}
                                        editingProfile={editingProfile}
                                        clearEditingProfile={() => setEditingProfile(null)}
                                        handleAddNewMapping={() => {
                                            handleSelectedKey("manageMappings");
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            {!bodyOnly && <Modal.Footer className="gc-footer">
                <button
                    type="button"
                    className="gc-footer-close-btn"
                    onClick={() => handleModalShowHide("")}
                >
                    <i className="fa fa-times" /> Close
                </button>
            </Modal.Footer>}
        </Container>
    </>

}

export default GenerateContract;
